import { httpClient } from '@bs/core'
import type { PantryNavApiResponse } from '../../types/pantryNavigation'

interface ApiEnvelope<T> {
  data?: T
}

const unwrap = (
  res:
    | ApiEnvelope<PantryNavApiResponse>
    | PantryNavApiResponse
    | null
    | undefined,
): PantryNavApiResponse | null => {
  if (!res) return null
  if (
    typeof res === 'object' &&
    'data' in res &&
    (res as ApiEnvelope<PantryNavApiResponse>).data
  ) {
    return (res as ApiEnvelope<PantryNavApiResponse>).data ?? null
  }
  return res as PantryNavApiResponse
}

export const pantryNavigationApis = {
  get: async (storeId: string): Promise<PantryNavApiResponse | null> => {
    const raw = (await httpClient.json.get(
      `/unification/pantry_navigation?bs_store_id=${storeId}&source=breadstack`,
    )) as ApiEnvelope<PantryNavApiResponse> | PantryNavApiResponse
    return unwrap(raw)
  },
}
